export type LocProfile = {
  [key in Features]: boolean;
} & {
  DebitProcessor: string;
  DefaultCustomerTypeId: number;
  DefaultDeliveryWindowEnd: string;
  DefaultDeliveryWindowStart: string;
  IntegratedState: string;
  LicenseTypeIds: Record<string, unknown>[];
  UseLabPackageDate: boolean;
  UseMETRCUseByDate: boolean;
};

export enum Features {
  AcceptCanPay = 'AcceptCanPay',
  AcceptHypur = 'AcceptHypur',
  AcceptLinx = 'AcceptLinx',
  APIActionsQueued = 'APIActionsQueued',
  AuditCustomerInfoAccess = 'AuditCustomerInfoAccess',
  BulkRegisterTransactions = 'BulkRegisterTransactions',
  BulkUploadLabData = 'BulkUploadLabData',
  CanadaBarcodeScanning = 'CanadaBarcodeScanning',
  CanUseMassDPHIntegration = 'CanUseMassDPHIntegration',
  CheckMetrcOnHoldInventory = 'CheckMetrcOnHoldInventory',
  CheckOutCheck = 'CheckOutCheck',
  CheckOutCreditCard = 'CheckOutCreditCard',
  CheckOutDebit = 'CheckOutDebit',
  CombinePackages = 'CombinePackages',
  CustomerPaymentSurcharge = 'CustomerPaymentSurcharge',
  CustomerVisitReason = 'CustomerVisitReason',
  DaysSupplyPurchaseLimits = 'DaysSupplyPurchaseLimits',
  DiscountWizardEnablement = 'DiscountWizardEnablement',
  DualPricing = 'DualPricing',
  EcomV2 = 'EcomV2',
  EnableAGCOReport = 'EnableAGCOReport',
  EnableAutoMatchingDuringReceive = 'EnableAutoMatchingDuringReceive',
  EnableDelivery = 'EnableDelivery',
  EnableManualPayments = 'EnableManualPayments',
  EnableNutrientTracking = 'EnableNutrientTracking',
  EnablePlantSearch = 'EnablePlantSearch',
  EnableUntrackedInventoryTransfers = 'EnableUntrackedInventoryTransfers',
  FixedTablesBeta = 'FixedTablesBeta',
  FormValidation = 'FormValidation',
  GeneriPayBirchmount = 'GeneriPayBirchmount',
  GeneriPayG2 = 'GeneriPayG2',
  GeneriPayTFI = 'GeneriPayTFI',
  HasBioTrack = 'HasBioTrack',
  HasDutchiePay = 'HasDutchiePay',
  HasJory = 'HasJory',
  HasLooker = 'HasLooker',
  HasLookerExplorer = 'HasLookerExplorer',
  HasMCDMS = 'HasMCDMS',
  HasMETRC = 'HasMETRC',
  HasMMUR = 'HasMMUR',
  HasPaymentsHub = 'HasPaymentsHub',
  HasPaymentsHubWhiteLabel = 'HasPaymentsHubWhiteLabel',
  HasPaynetworx = 'HasPaynetworx',
  HasPercentPaymentFees = 'HasPercentPaymentFees',
  HasPlanetPayments = 'HasPlanetPayments',
  HasPurchasOrders = 'HasPurchasOrders',
  HasReThink = 'HasReThink',
  HasUtahICS = 'HasUtahICS',
  HasVCCB = 'HasVCCB',
  HasVirginiaBioTrack = 'HasVirginiaBioTrack',
  HideMarketingHighlights = 'HideMarketingHighlights',
  InvReconUpdateInBulk = 'InvReconUpdateInBulk',
  IsLeaflyEnabled = 'IsLeaflyEnabled',
  IsLicensed = 'IsLicensed',
  IsWeedMapsEnabled = 'IsWeedMapsEnabled',
  LocationBasedDelivery = 'LocationBasedDelivery',
  LocationSyncTool = 'LocationSyncTool',
  LoyaltyAndMarketingSubscriber = 'LoyaltyAndMarketingSubscriber',
  LoyaltyAsCartDiscount = 'LoyaltyAsCartDiscount',
  LoyaltyAsDiscount = 'LoyaltyAsDiscount',
  ManagerPinRequiredInventoryAdjustmentThreshold = 'ManagerPinRequiredInventoryAdjustmentThreshold',
  Manufacturing = 'Manufacturing',
  MarketingCampaignAdvancedUtmFields = 'MarketingCampaignAdvancedUtmFields',
  MedAndRecShareBasePrice = 'MedAndRecShareBasePrice',
  METRCFinishPackages = 'METRCFinishPackages',
  NewIAManufacturingModule = 'NewIAManufacturingModule',
  NoDoublePreOrder = 'NoDoublePreOrder',
  NYSPMP = 'NYSPMP',
  OrdersbyProduct = 'OrdersbyProduct',
  PlantReconciliation = 'PlantReconciliation',
  POSStatus = 'POSStatus',
  PrintPickTicketOnArrival = 'PrintPickTicketOnArrival',
  RecFlowerEquiv = 'RecFlowerEquiv',
  RequireReasonForAdjustments = 'RequireReasonForAdjustments',
  ScanParentPackageSerialNumber = 'ScanParentPackageSerialNumber',
  SendWetWeightToInventory = 'SendWetWeightToInventory',
  ShowBulkCustomerPiiWipeTool = 'ShowBulkCustomerPiiWipeTool',
  ShowCultivationIntegrationReconcilation = 'ShowCultivationIntegrationReconcilation',
  ShowCultivationTax = 'ShowCultivationTax',
  ShowExciseTaxOnReceive = 'ShowExciseTaxOnReceive',
  ShowExternalLoyalty = 'ShowExternalLoyalty',
  ShowLeafLogixLoyalty = 'ShowLeafLogixLoyalty',
  ShowPinDebitNonCashAdjustment = 'ShowPinDebitNonCashAdjustment',
  ShowSourcePackage = 'ShowSourcePackage',
  ShowStateBypass = 'ShowStateBypass',
  ShowZeroInventory = 'ShowZeroInventory',
  TaxInclusivePricing = 'TaxInclusivePricing',
  TrackImmaturePlantsIndividually = 'TrackImmaturePlantsIndividually',
  TrackInventoryIds = 'TrackInventoryIds',
  UseAdilas = 'UseAdilas',
  UseAlpineIQ = 'UseAlpineIQ',
  UseBioMauris = 'UseBioMauris',
  UseBioTrack = 'UseBioTrack',
  UseCCRS = 'UseCCRS',
  UseDistillationMethod = 'UseDistillationMethod',
  UseEmailMarketing = 'UseEmailMarketing',
  UseFeesDonations = 'UseFeesDonations',
  UseFlowerEquivalencyDefinition = 'UseFlowerEquivalencyDefinition',
  UseFyllo = 'UseFyllo',
  UseGoodCannaIntegration = 'UseGoodCannaIntegration',
  UseIDScan = 'UseIDScan',
  UseInfusions = 'UseInfusions',
  UseLeaf = 'UseLeaf',
  UseLeafLink = 'UseLeafLink',
  UseManufacturers = 'UseManufacturers',
  UseMCDMS = 'UseMCDMS',
  UseMETRC = 'UseMETRC',
  UseMETRCUseByDate = 'UseMETRCUseByDate',
  UseMMUR = 'UseMMUR',
  UseMn = 'UseMn',
  UseMultiPackageCreator = 'UseMultiPackageCreator',
  UseMultiStopManifests = 'UseMultiStopManifests',
  UseNewPOS = 'UseNewPOS',
  UseOCS = 'UseOCS',
  UseOnFleet = 'UseOnFleet',
  UseOrderFulfill = 'UseOrderFulfill',
  UsePinLogin = 'UsePINLogin',
  UsePMP = 'UsePMP',
  UsePushMarketing = 'UsePushMarketing',
  UseQuickBooks = 'UseQuickBooks',
  UseSkylightDebitIntegration = 'UseSkylightDebitIntegration',
  UseSMSMarketing = 'UseSMSMarketing',
  UseSpinDebitIntegration = 'UseSpinDebitIntegration',
  UseSpringBig = 'UseSpringBig',
  UseSprout = 'UseSprout',
  UseSSO = 'UseSSO',
  UseStandardAllergens = 'UseStandardAllergens',
  UseTookan = 'UseTookan',
  UseTranCloudDebitIntegration = 'UseTranCloudDebitIntegration',
  UseTrym = 'UseTrym',
  UseUtahICS = 'UseUtahICS',
  UseVCCB = 'UseVCCB',
  UseVirginiaBioTrack = 'UseVirginiaBioTrack',
  UseWorkflowMarketing = 'UseWorkflowMarketing',
  UseWorkWave = 'UseWorkWave',
  ViewOrgManagement = 'ViewOrgManagement',
  WeedmapsV2 = 'WeedmapsV2',
  WholesaleCarsAndDrivers = 'WholesaleCarsAndDrivers',
}
